import { motion } from 'framer-motion';

interface ActionButtonsProps {
  onPlayAgain: () => void;
  onReturnHome: () => void;
  shareDetailsText: string;
  isHost: boolean;
}

export function ActionButtons({
  onPlayAgain,
  onReturnHome,
  shareDetailsText,
  isHost,
}: ActionButtonsProps) {
  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(shareDetailsText);
      alert('Match performance statistics copied to clipboard!');
    } catch {
      alert('Clipboard access blocked.');
    }
  };

  return (
    <div className="w-full flex items-center justify-center p-4 z-30 select-none">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full max-w-2xl">
        {/* Play Again */}
        {isHost && (
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={onPlayAgain}
            style={{
              boxShadow: '0 4px 15px rgba(124, 58, 237, 0.25)',
            }}
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-gradient-to-r from-purple-600 to-pink-500 hover:from-purple-500 hover:to-pink-400 text-white font-black text-xs uppercase tracking-widest cursor-pointer shadow-glow"
          >
            Play Again
          </motion.button>
        )}

        {/* Share Results */}
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={handleShare}
          style={{
            boxShadow: 'inset 0 0 10px rgba(255,255,255,0.02)',
          }}
          className="w-full sm:w-auto px-8 py-3 rounded-full bg-slate-900/40 hover:bg-slate-900/80 border border-white/10 text-white font-black text-xs uppercase tracking-widest cursor-pointer"
        >
          Share Results
        </motion.button>

        {/* Return Home */}
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={onReturnHome}
          className="w-full sm:w-auto px-8 py-3 rounded-full bg-transparent hover:bg-white/5 text-surface-300 hover:text-white font-bold text-xs uppercase tracking-wider cursor-pointer"
        >
          Return Home
        </motion.button>
      </div>
    </div>
  );
}
export default ActionButtons;
